import { get, patch } from '../../utils/http';

export const fetchOrgTypes = ({ accountId, kind }) => get(`/accounts/${accountId}/org/${kind}`);

export const fetchOrgVenues = ({ accountId, attachedToAccount }) =>
  get(`/accounts/${accountId}/org/venues`, attachedToAccount ? { attachedToAccount: true } : {});

export const fetchOrgContracts = ({ accountId }) => get(`/accounts/${accountId}/org/contracts`);

export const setLocationOrgVenue = ({ accountId, locationId, orgVenueId }) =>
  patch(`/accounts/${accountId}/org/assignments/locations/${locationId}/venue`, { orgVenueId });

export const setLocationOrgContract = ({ accountId, locationId, orgContractId }) =>
  patch(`/accounts/${accountId}/org/assignments/locations/${locationId}/contract`, { orgContractId });

export const setAreaOrgType = ({ accountId, areaId, orgTypeId }) =>
  patch(`/accounts/${accountId}/org/assignments/areas/${areaId}`, { orgTypeId });
